export const hasMA = {
  BRA: true,
};

export const mapAndFieldException = {
  FLK: true,
  GUY: true,
  SUR: true,
};
